import {
  LIST_MCU_PROJECT_PACKAGE_REQUEST,
  LIST_MCU_PROJECT_PACKAGE_SUCCESS,
  LIST_MCU_PROJECT_PACKAGE_FAIL,
  LIST_MCU_PROJECT_PACKAGE_SUMMARY_REQUEST,
  LIST_MCU_PROJECT_PACKAGE_SUMMARY_SUCCESS,
  LIST_MCU_PROJECT_PACKAGE_SUMMARY_FAIL,
  CREATE_MCU_PROJECT_PACKAGE_REQUEST,
  CREATE_MCU_PROJECT_PACKAGE_SUCCESS,
  CREATE_MCU_PROJECT_PACKAGE_FAIL,
  DETAIL_MCU_PROJECT_PACKAGE_REQUEST,
  DETAIL_MCU_PROJECT_PACKAGE_SUCCESS,
  DETAIL_MCU_PROJECT_PACKAGE_FAIL,
  UPDATE_MCU_PROJECT_PACKAGE_REQUEST,
  UPDATE_MCU_PROJECT_PACKAGE_SUCCESS,
  UPDATE_MCU_PROJECT_PACKAGE_FAIL,
  DELETE_MCU_PROJECT_PACKAGE_REQUEST,
  DELETE_MCU_PROJECT_PACKAGE_SUCCESS,
  DELETE_MCU_PROJECT_PACKAGE_FAIL,
  RESET_MCU_PROJECT_PACKAGE,
  LIST_PACKAGE_ADDITIONAL_INFO_REQUEST,
  LIST_PACKAGE_ADDITIONAL_INFO_SUCCESS,
  LIST_PACKAGE_ADDITIONAL_INFO_FAIL,
  CREATE_PACKAGE_ADDITIONAL_INFO_REQUEST,
  CREATE_PACKAGE_ADDITIONAL_INFO_SUCCESS,
  CREATE_PACKAGE_ADDITIONAL_INFO_FAIL,
  DELETE_PACKAGE_ADDITIONAL_INFO_REQUEST,
  DELETE_PACKAGE_ADDITIONAL_INFO_SUCCESS,
  DELETE_PACKAGE_ADDITIONAL_INFO_FAIL,
  LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_REQUEST,
  LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_SUCCESS,
  LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_FAIL,
  GET_MCU_PACKAGE_SUMMARIES_REQUEST,
  GET_MCU_PACKAGE_SUMMARIES_SUCCESS,
  GET_MCU_PACKAGE_SUMMARIES_FAIL,
  GET_MCU_PACKAGE_SUPPORTING_DOCS_REQUEST,
  GET_MCU_PACKAGE_SUPPORTING_DOCS_SUCCESS,
  GET_MCU_PACKAGE_SUPPORTING_DOCS_FAIL
} from '../../constants/mcu-project-package'

const initialState = {
  loading: false,
  loadingDelete: false,
  loadingCreate: false,
  loadingServiceAdditionalInfo: false,
  loadingSupportingDocs: false,
  mcuProjectPackageServiceAdditionalInfo: [],
  mcuProjectPackages: [],
  mcuProjectPackageAdditionalInfo: [],
  mcuProjectPackageSupportingDocs: [],
  mcuProjectPackage: {},
  mcuAllPackage: [],
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const mcuProjectReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_MCU_PROJECT_PACKAGE_REQUEST:
      return { ...state, loading: true }
    case LIST_MCU_PROJECT_PACKAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        mcuProjectPackages: action.payload,
        pageable: action.pageable
      }
    case LIST_MCU_PROJECT_PACKAGE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        mcuProjectPackages: action?.dummy
      }
    case LIST_MCU_PROJECT_PACKAGE_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_MCU_PROJECT_PACKAGE_SUMMARY_SUCCESS:
      return { ...state, loading: false, mcuProjectPackages: action.payload }
    case LIST_MCU_PROJECT_PACKAGE_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case CREATE_MCU_PROJECT_PACKAGE_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_MCU_PROJECT_PACKAGE_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_MCU_PROJECT_PACKAGE_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_MCU_PROJECT_PACKAGE_REQUEST:
      return { ...state, loadingDetail: true, mcuProjectPackage: {} }
    case DETAIL_MCU_PROJECT_PACKAGE_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        mcuProjectPackage: action.payload
      }
    case DETAIL_MCU_PROJECT_PACKAGE_FAIL:
      return { ...state, loadingDetail: false, error: action.payload, mcuProjectPackage: action?.dummy }
    case UPDATE_MCU_PROJECT_PACKAGE_REQUEST:
      return { ...state, loadingCreate: true }
    case UPDATE_MCU_PROJECT_PACKAGE_SUCCESS:
      return { ...state, loadingCreate: false }
    case UPDATE_MCU_PROJECT_PACKAGE_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DELETE_MCU_PROJECT_PACKAGE_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_MCU_PROJECT_PACKAGE_SUCCESS:
      return { ...state, loadingDelete: false }
    case DELETE_MCU_PROJECT_PACKAGE_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case RESET_MCU_PROJECT_PACKAGE:
      return { ...state, loading: false, error: null }
    case LIST_PACKAGE_ADDITIONAL_INFO_REQUEST:
      return { ...state, loading: true }
    case LIST_PACKAGE_ADDITIONAL_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        mcuProjectPackageAdditionalInfo: action.payload
      }
    case LIST_PACKAGE_ADDITIONAL_INFO_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        mcuProjectPackageAdditionalInfo: []
      }
    case LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_REQUEST:
      return { ...state, loadingServiceAdditionalInfo: true }
    case LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_SUCCESS:
      return {
        ...state,
        loadingServiceAdditionalInfo: false,
        mcuProjectPackageServiceAdditionalInfo: action.payload
      }
    case LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_FAIL:
      return {
        ...state,
        loadingServiceAdditionalInfo: false,
        error: action.payload,
        mcuProjectPackageServiceAdditionalInfo: action?.dummy
      }
    case CREATE_PACKAGE_ADDITIONAL_INFO_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_PACKAGE_ADDITIONAL_INFO_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_PACKAGE_ADDITIONAL_INFO_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DELETE_PACKAGE_ADDITIONAL_INFO_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_PACKAGE_ADDITIONAL_INFO_SUCCESS:
      return { ...state, loadingDelete: false }
    case DELETE_PACKAGE_ADDITIONAL_INFO_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case GET_MCU_PACKAGE_SUMMARIES_REQUEST:
      return {
        ...state,
        loading: true
      }
    case GET_MCU_PACKAGE_SUMMARIES_SUCCESS:
      return {
        ...state,
        mcuAllPackage: action.payload,
        loading: false
      }
    case GET_MCU_PACKAGE_SUMMARIES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case GET_MCU_PACKAGE_SUPPORTING_DOCS_REQUEST:
      return { ...state, loadingSupportingDocs: true }
    case GET_MCU_PACKAGE_SUPPORTING_DOCS_SUCCESS:
      return {
        ...state,
        loadingSupportingDocs: false,
        mcuProjectPackageSupportingDocs: action.payload
      }
    case GET_MCU_PACKAGE_SUPPORTING_DOCS_FAIL:
      return {
        ...state,
        loadingSupportingDocs: false,
        error: action.payload,
        mcuProjectPackageSupportingDocs: []
      }
    default:
      return state
  }
}

export default mcuProjectReducer
